/**
 * Canonical PAYMENT_FAILED_REASONS from the API. They reach us as
 * `paymentsDetail.failed_reason` after a capture that answers 200 with a failed
 * payment. The gateway adapters translate every provider specific reason into
 * one of these, so provider strings never reach the browser.
 */
const failedReasons = {
  aborted: 'La transacción fue cancelada',
  card_blocked: 'La tarjeta está bloqueada',
  card_expired: 'La tarjeta está vencida',
  card_invalid: 'Los datos de la tarjeta son incorrectos',
  card_not_found: 'No encontramos la tarjeta',
  charge_duplicated: 'Ya registramos un pago igual hace instantes',
  charge_error: 'Hubo un problema al procesar la tarjeta',
  charge_max_amount_exceeded: 'El monto supera el límite de la tarjeta',
  charge_not_supported: 'La tarjeta no permite este tipo de pago',
  charge_rejected: 'El pago fue rechazado',
  max_retries_exceeded: 'Superaste el número máximo de intentos',
  no_funds: 'La tarjeta no tiene fondos suficientes',
  not_specified: 'El pago fue rechazado',
  provider_authentication_failed: 'No se pudo validar la tarjeta con el banco',
  provider_connection_failed: 'No pudimos conectarnos con la pasarela de pago',
  provider_currency_not_supported: 'La moneda no está disponible para este medio de pago',
  rejection_by_data: 'Los datos ingresados no son válidos',
  rejection_by_fraud_control: 'El pago fue rechazado por control de fraude',
  rejection_by_issuing: 'El banco emisor rechazó el pago'
}

/**
 * `code_error` values the API returns in the body of a 400.
 */
const errorCodes = {
  P002: 'El pago fue rechazado. Revisa los datos de tu tarjeta o prueba con otra.',
  P004: 'Este pago ya fue procesado.',
  P005: 'Este pago ya no está disponible.',
  P006: 'Tu pago está siendo procesado por Mercado Pago. No vuelvas a pagar: te confirmaremos en unos minutos.'
}

export { errorCodes, failedReasons }
